import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
// import { Link } from 'react-router-dom';
import { Button, Checkbox } from 'flowbite-react';
import { displayDateOnly } from '../../Utils';
import { useState } from 'react';
import Loader from '../Common/Loader';
import { ContactForm } from '../../Models/ContactForm';
export default function ContactFormListTable({
  data,
}: {
  data: ContactForm[];
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const columnHelper = createColumnHelper<ContactForm>();

  const columns = [
    columnHelper.accessor((row) => row.companyName, {
      id: 'companyName',
      header: 'Company Name',
      cell: (info) => info.getValue() ?? '',
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.firstName, {
      id: 'firstName',
      header: 'First Name',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.lastName, {
      id: 'lastName',
      header: 'Last Name',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.email, {
      id: 'email',
      header: 'Email',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.phone, {
      id: 'phone',
      header: 'Phone',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.subject, {
      id: 'subject',
      header: 'Subject',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.questionsComments, {
      id: 'questionsComments',
      header: 'Questions/Comments',
      footer: (info) => info.column.id,
      enableColumnFilter: true,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        {isLoading && <Loader />}
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
